module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right-tabs"
  }, [_c('div', {
    ref: "header",
    staticClass: "header"
  }, [_c('ul', [_c('li', {
    staticClass: "close-button",
    on: {
      "click": _vm.close
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.tab == 0
    },
    on: {
      "click": function($event) {
        _vm.tab = 0
      }
    }
  }, [_c('translate', {
    attrs: {
      "translate-context": "windgram tab"
    }
  }, [_vm._v("Windgram")])], 1), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.tab == 1
    },
    on: {
      "click": function($event) {
        _vm.tab = 1
      }
    }
  }, [_c('translate', {
    attrs: {
      "translate-context": "windgram tab"
    }
  }, [_vm._v("Sounding")])], 1), _vm._v(" "), _c('li', {
    staticClass: "unit"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.windUnit),
      expression: "windUnit"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.windUnit = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "kmh"
    }
  }, [_c('translate', [_vm._v("km/h")])], 1), _vm._v(" "), _c('option', {
    attrs: {
      "value": "knots"
    }
  }, [_c('translate', [_vm._v("knots")])], 1), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ms"
    }
  }, [_c('translate', [_vm._v("m/s")])], 1), _vm._v(" "), _c('option', {
    attrs: {
      "value": "mph"
    }
  }, [_c('translate', [_vm._v("mph")])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('keep-alive', [(_vm.tab == 0) ? _c('alti-winds-view', {
    attrs: {
      "redraw": _vm.redraw
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('keep-alive', [(_vm.tab == 1) ? _c('sounding-view', {
    attrs: {
      "redraw": _vm.redraw
    }
  }) : _vm._e()], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-20698bee"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/right-tabs.vue
// module id = 329
// module chunks = 1